import React from 'react';

import Banner from './Banner';

const UnsupportedBrowserBanner = () => {
    return (
        <Banner isWarning>
            <p>
                This browser is not supported. Please see the Customer Requirements site for more
                information.
            </p>
        </Banner>
    );
};

export default UnsupportedBrowserBanner;
